import { Controller } from "@hotwired/stimulus"

// Copies the master row's values (category, description, amount) down into
// every row below it. Only non-blank master fields are applied, so a partially
// filled master won't wipe out values already entered in the rows.
export default class FillDownController extends Controller {
  static targets = [
    "masterCategory", "masterDescription", "masterAmount",
    "category", "description", "amount",
  ]

  declare masterCategoryTarget: HTMLSelectElement
  declare masterDescriptionTarget: HTMLInputElement
  declare masterAmountTarget: HTMLInputElement
  declare categoryTargets: HTMLSelectElement[]
  declare descriptionTargets: HTMLInputElement[]
  declare amountTargets: HTMLInputElement[]

  applyAll(): void {
    this.fill(this.masterCategoryTarget, this.categoryTargets)
    this.fill(this.masterDescriptionTarget, this.descriptionTargets)
    this.fill(this.masterAmountTarget, this.amountTargets)
  }

  private fill(
    master: HTMLInputElement | HTMLSelectElement,
    rows: (HTMLInputElement | HTMLSelectElement)[],
  ): void {
    const value = master.value
    if (value === "") return

    for (const row of rows) {
      row.value = value
      row.dispatchEvent(new Event("input", { bubbles: true }))
      row.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
